import { Icon, ICONS, StickyWrapper } from '@bob/library'
import { useStaticText } from '@websrc/App/Hooks/useStaticText'
import React, { RefObject, useCallback, useEffect, useState } from 'react'

import * as SC from './SpotCollapse.style'

function useOverrideIsSticky(buttonRef: RefObject<HTMLButtonElement | null>) {
  const [overrideIsSticky, setOverrideIsSticky] = useState<boolean | undefined>()

  // Ensure all wrappers listen for resize and scroll.
  const calculate = useCallback(() => {
    let currOverrideIsSticky
    const bottom = buttonRef.current?.getBoundingClientRect().bottom ?? 0

    if (bottom > window.innerHeight - 100) {
      currOverrideIsSticky = false
    }

    if (overrideIsSticky !== currOverrideIsSticky) {
      setOverrideIsSticky(currOverrideIsSticky)
    }
  }, [overrideIsSticky, buttonRef])

  useEffect(() => {
    document.addEventListener('scroll', calculate, true)
    window.addEventListener('resize', calculate)

    return () => {
      document.removeEventListener('scroll', calculate, true)
      window.removeEventListener('resize', calculate)
    }
  })

  return overrideIsSticky
}

interface SpotCollapseBarProps {
  buttonRef: RefObject<HTMLButtonElement | null>
  scrollRef: RefObject<HTMLDivElement | null>
  onCollapse: () => void
}

export function SpotCollapseBar({ scrollRef, buttonRef, onCollapse }: SpotCollapseBarProps) {
  const overrideIsSticky = useOverrideIsSticky(buttonRef)
  const t = useStaticText()

  return (
    <StickyWrapper fullWidth={true} overrideIsSticky={overrideIsSticky} position={'bottom'}>
      {(isSticky) => (
        <SC.ButtonWrapper isSticky={isSticky}>
          <SC.Button
            onClick={() => {
              onCollapse()

              if (scrollRef.current) {
                window.scrollTo({
                  behavior: 'smooth',
                  top: scrollRef.current.getBoundingClientRect().top + window.scrollY - 100,
                })
              }
            }}
          >
            <Icon icon={ICONS.MINUS} />
            <span>{t.spot.collapse_spot}</span>
          </SC.Button>
        </SC.ButtonWrapper>
      )}
    </StickyWrapper>
  )
}
